// extracted by mini-css-extract-plugin
export default {"sort":"sort_sort__e3+ri","column":"sort_column__kUfAD"};